import { FormContent, Wrapper } from '@maxtropy/components';
import { Button, Col, Form, Modal, Row, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import styles from '../index.module.scss';
import SelectTenant from './SelectTenant';
import { useLocation, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import ShowInput from '@/shared/components/ShowInput';
import {
  getTemplateDistributionTenant,
  templateBindingTenant,
  TemplateDistributionTenantRes,
} from '../../../api/edgeTemplate';

const routes = [{ name: 'Iot配置' }, { name: '数采配置' }, { name: '模板分配' }, { name: '租户分配数采模板' }];

const formLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 18 },
};

const TenantDistribution: React.FC = () => {
  const [form] = Form.useForm();
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const navigate = useNavigate();
  const [info, setInfo] = useState<TemplateDistributionTenantRes>();
  const [modalApi, modalContextHolder] = Modal.useModal();

  useEffect(() => {
    if (id) {
      getTemplateDistributionTenant(id).then(res => {
        setInfo(res);
        form.setFieldsValue(res);
      });
    }
  }, [id, form]);

  const goList = () => {
    navigate(`/device/edge/distribution${search}`);
  };

  const onCacel = () => {
    modalApi.confirm({
      title: null,
      icon: null,
      content: <div>是否放弃所有未保存信息并返回列表？</div>,
      onOk: goList,
    });
  };

  const onFinish = (value: TemplateDistributionTenantRes) => {
    if (id) {
      const currentIds = (value.tenantList ?? []).map(i => i.rootMcid);
      const tenantsId = (info?.tenantList ?? []).map(i => i.rootMcid);
      let params = {};
      if (tenantsId.length === 0) {
        params = {
          addTenantMcidList: currentIds,
        };
      } else {
        params = {
          deleteTenantMcidList: tenantsId.filter(i => !currentIds.includes(i)),
          addTenantMcidList: currentIds.filter(i => !tenantsId.includes(i)),
        };
      }
      templateBindingTenant({ templateId: id, ...params }).then(res => {
        console.log(res);
        if (res) goList();
      });
    }
  };

  return (
    <Wrapper routes={routes} className={styles.wrapper}>
      <Form form={form} layout="vertical" onFinish={onFinish} {...formLayout}>
        <FormContent title="模板信息">
          <Row className={styles.row}>
            <Col span={12} className={styles.col}>
              <Form.Item label="模板code" name="code">
                <ShowInput />
              </Form.Item>
            </Col>
            <Col span={12} className={styles.col}>
              <Form.Item label="模板名称" name="name">
                <ShowInput />
              </Form.Item>
            </Col>
          </Row>
        </FormContent>
        <FormContent title="分配租户">
          <Form.Item name="tenantList" wrapperCol={{ span: 24 }}>
            <SelectTenant />
          </Form.Item>
        </FormContent>
        <Space className="sticky-footer">
          <Button type="primary" htmlType="submit">
            保存
          </Button>
          <Button className={styles.button} onClick={onCacel}>
            取消
          </Button>
        </Space>
      </Form>
      {modalContextHolder}
    </Wrapper>
  );
};

export default TenantDistribution;
